import styled from "styled-components";
import { Card } from "antd";

export const CardCustom = styled(Card)`
  margin-top: 13px !important;
  overflow-x: hidden;
  border-radius: 7px !important;
  background: #fff !important;
  box-shadow: 0px 0px 10px #d8d8d8 !important;
  overflow-y: hidden;
  padding: 0px !important;

  .tableCustom {
    .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td,
    .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td,
    .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td,
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
      background-color: inherit !important;
      text-shadow: none;
    }
  }

  .ant-card-body {
    padding-top: 14px;
  }

  .rowHeader {
    margin-bottom: 17px;
  }

  .filterRow {
    margin-top: 16px;
    margin-bottom: 16px;
    .ant-row:first-child {
      margin-bottom: 8px;
    }
  }
  .filterLabel {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;
  }
  .table-row-green {
    color: rgb(51, 193, 98);
  }

  .table-row-red {
    color: rgb(212, 76, 76);
  }

  .table-row-gray {
    background: rgb(238, 238, 238) !important;

    &:hover {
      background: rgb(238, 238, 238) !important;
    }
  }
  .ant-table-row.table-row-gray:hover {
    background: rgb(238, 238, 238) !important;
  }

  .ant-table-row.table-row-gray:nth-child(even) {
    background: rgb(238, 238, 238) !important;
  }
`;

export const Title = styled.span`
  font-size: 18px;
  font-weight: bold;
  font-family: "Asap", sans-serif;
`;

export const PageTitle = styled.span`
  font-family: Asap;
  font-weight: bold;
  font-size: 25px;
  text-align: left;
  color: #9074bf;
`;
